<template>
  <div class="page-wecom-uauth-entry"></div>
</template>
<script>
import { postEid } from '../../../../utils/wecom/index';
export default {
  name: 'Entry',
  async created() {
    this.$loading.show();
    await postEid().catch(ex => {
      console.log(ex);
    });
  }
};
</script>
